import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, tap } from 'rxjs/operators';
import { editCustomField } from '@capital-access/common/actions';
import { CommonLazyLoadingService } from '@capital-access/common/lazy-loading';
import { CUSTOM_FIELD_EDIT_MODULE_ID, LOAD_CUSTOM_FIELD_EDIT_MODULE } from '../edit-loader-module-id.model';

@Injectable()
export class EditEffects {
  editCustomField$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(editCustomField),
        switchMap(({ id, entityType, addBackButton }) =>
          this.commonLazyLoadingService
            .loadModule(CUSTOM_FIELD_EDIT_MODULE_ID, LOAD_CUSTOM_FIELD_EDIT_MODULE)
            .pipe(tap(moduleRef => moduleRef.instance.showCustomFieldEditForm(id, entityType, addBackButton || false)))
        )
      ),
    { dispatch: false }
  );

  constructor(private actions$: Actions, private commonLazyLoadingService: CommonLazyLoadingService) {}
}
